"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function SecurityeventsGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#6C757D",
    clipPath: "url(#prefix__securityevents-grey-outline__clip0_17069_4223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.734 2.94a2.486 2.486 0 00-1.063-1.513 2.551 2.551 0 00-.71-.331 2.445 2.445 0 00-.883-.088l-.112.012c-.016 0-.027 0-.043.008-.08.008-.16.024-.24.044a1.96 1.96 0 00-.164.044c-.036.012-.068.02-.1.032a3.235 3.235 0 00-.427.2 2.315 2.315 0 00-.575.463 2.465 2.465 0 00-.291.379l-.072.12a2.782 2.782 0 00-.076.155 1.297 1.297 0 00-.072.172 2.255 2.255 0 00-.104.351c-.008.032-.016.06-.02.092a1.001 1.001 0 00-.016.108c0 .02-.008.044-.008.064-.012.092-.016.18-.016.272 0 .051 0 .103.004.155.008.104.02.204.036.308.012.048.02.1.032.148a2.696 2.696 0 00.22.575c.024.043.048.087.076.131.032.06.072.12.116.176a2.292 2.292 0 00.491.511c.052.04.103.08.16.116.407.267.89.42 1.397.42.192 0 .391-.025.587-.073a2.534 2.534 0 001.873-3.05zm-2.057 2.277a1.738 1.738 0 01-1.361-.24c-.036-.024-.072-.048-.104-.08a1.37 1.37 0 01-.303-.303 1.717 1.717 0 01-.264-.467c-.02-.06-.036-.12-.052-.18a1.742 1.742 0 01.235-1.374c.008-.008.012-.02.024-.028.028-.044.06-.088.092-.127l.036-.04a1.09 1.09 0 01.136-.136c.004-.004.004-.008.008-.008.048-.048.104-.088.16-.128a1.7 1.7 0 01.183-.108c.052-.028.108-.056.164-.076.012 0 .028-.012.044-.016a.976.976 0 01.184-.055l.008-.004c.052-.012.103-.024.155-.028.084-.012.168-.02.256-.02.048 0 .096.004.144.008.048.004.095.008.14.016.047.008.095.02.143.032.092.02.18.051.268.091.044.02.087.04.127.064a1.737 1.737 0 01.858 1.118 1.74 1.74 0 01-1.28 2.089zM5.343 11.66v-.678c-.22.383-.492.758-.8 1.133v.344h.748l.323-.42.248-.379h-.52zm9.527-4.2a3.836 3.836 0 00-2.731-1.13h-.184l-1.681 1.924-1.685-1.924h-.184c-.092 0-.183.004-.275.012h-.024s-.012 0-.02.004a4.05 4.05 0 00-.623.1l-.04.011c-.108.028-.216.064-.324.1a3.022 3.022 0 00-.61.284.12.12 0 00-.032.016l.387.699s.008-.004.012-.008a3.777 3.777 0 01.595-.268c.076-.024.152-.048.227-.064.084-.02.168-.04.252-.052.08-.012.16-.02.24-.028.02 0 .04-.004.06-.004l2.044 2.336 2.04-2.336a3.046 3.046 0 011.993.895c.579.579.894 1.345.894 2.164v1.47H6.405l-.611.798H16v-2.268c0-1.03-.4-2-1.13-2.731zm-8.537-.052l-.212-.332-.096.072a1.692 1.692 0 00-.095.08 3.515 3.515 0 00-.404.391c.168.252.292.535.356.839a3.027 3.027 0 01.63-.67l-.18-.38zM4.935 8.495a3.85 3.85 0 00-.391 1.697v.132a1.673 1.673 0 00.391-1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.055 9.118c0 .471-.196.902-.511 1.206v-.132c0-.6.136-1.174.391-1.697.076.192.12.403.12.623zM4.544 12.117a8.4 8.4 0 00.799-1.135v1.286h-.8v-.151zM6.512 7.788a3.028 3.028 0 00-.63.67 2.408 2.408 0 00-.356-.838 3.518 3.518 0 01.403-.391c.032-.028.064-.056.096-.08a.877.877 0 01.1-.068M8.405 6.33v.8c-.056 0-.116.003-.176.003-.02 0-.04.004-.06.004a2.813 2.813 0 00-.491.08c-.075.016-.151.04-.227.064a3.773 3.773 0 00-.607.276l-.387-.695s.02-.016.031-.02a3.853 3.853 0 01.935-.384l.04-.012a4.05 4.05 0 01.623-.1c.008-.003.012-.003.02-.003h.024c.091-.008.183-.012.275-.012zM8.877 5.644a2.537 2.537 0 01-.711-3.51 2.528 2.528 0 013.506-.71l-.444.666a1.734 1.734 0 00-2.4.487 1.735 1.735 0 00.488 2.4l-.443.667h.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.935 8.495a1.684 1.684 0 00-1.56-1.058c-.927 0-1.682.754-1.682 1.68 0 .927.755 1.682 1.681 1.682.455 0 .867-.18 1.17-.475a1.673 1.673 0 00.391-1.83zM3.375 10a.883.883 0 110-1.765.883.883 0 010 1.765zm1.56-1.505a1.684 1.684 0 00-1.56-1.058c-.927 0-1.682.754-1.682 1.68 0 .927.755 1.682 1.681 1.682.455 0 .867-.18 1.17-.475a1.673 1.673 0 00.391-1.83zM3.375 10a.883.883 0 110-1.765.883.883 0 010 1.765zm3.138-2.212a3.46 3.46 0 00-.388-.707s0-.004-.004-.004a3.367 3.367 0 00-2.747-1.421A3.378 3.378 0 000 9.03c0 1.86 1.49 3.61 3.099 5.223l.283.283.284-.283A20.521 20.521 0 005.29 12.46c.207-.264.399-.527.567-.799.543-.846.89-1.725.89-2.631 0-.44-.084-.859-.235-1.242zm-1.17 3.195c-.22.383-.491.758-.799 1.134-.351.435-.747.862-1.162 1.285C2.06 12.05.8 10.5.8 9.03c0-1.47 1.154-2.576 2.575-2.576A2.57 2.57 0 015.526 7.62c.168.252.292.536.356.839.044.184.068.375.068.571 0 .655-.232 1.31-.607 1.953zM3.374 7.437c-.926 0-1.681.754-1.681 1.68 0 .927.755 1.682 1.681 1.682.455 0 .867-.18 1.17-.475a1.673 1.673 0 00.391-1.83 1.684 1.684 0 00-1.56-1.057zm0 2.563a.883.883 0 110-1.765.883.883 0 010 1.765z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__securityevents-grey-outline__clip0_17069_4223"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

SecurityeventsGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
SecurityeventsGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = SecurityeventsGreyOutline;
exports["default"] = _default;